import SumPanel from '@/views/finance/components/bill/SumPanel'

export default{
  components:{
    SumPanel
  },
  data(){
    return {
      // 会员卡明细
      sumLabel:{
        totalTradeAmount:'订单总金额(元)',
        totalTradeCnt:'订单数(笔)',
        totalSettlementAmount:'应结算金额(元)',
        totalRealSettlementAmount:'实际结算总金额(元)',
        totalServiceFee:'手续费(元)'
      },
      sumInfo:{
        totalTradeAmount: '0.00',
        totalTradeCnt: '0.00',
        totalSettlementAmount: '0.00',
        totalRealSettlementAmount: '0.00',
        totalServiceFee: '0.00'
      },
      sumDetailLabel:{
        totalOrderAmount:'订单总金额(元)',
        orderCount:'订单数(笔)',
        settlementAmount:'应结算金额(元)',
        realSettlementAmount:'实际结算总金额(元)',
        serviceFee:'手续费(元)'
      },
      sumDetailInfo:{
        totalOrderAmount: '0.00',
        orderCount: '0.00',
        settlementAmount: '0.00',
        realSettlementAmount: '0.00',
        serviceFee: '0.00'
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        },
        // 限制时间选择范围32天
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  }
}
